import React, { Component } from 'react';
import { Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { addDataOnBar, splitItems } from '../modules/helpers';
import { MASTER_DASHBOARD_CHART_TYPE } from "../common/constants";

const printTimeSet = {
    labels: [],
    datasets: [
        {
            label: 'print',
            backgroundColor: 'rgba(75,192,192,1)',
            data: []
        }
    ]
};

const RESIN_ITEM_HEIGHT = 48;
const DEFAULT_RESIN = "all";

export default class PrintDataPrintTime extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            selectedResin: DEFAULT_RESIN,
            printTimeSet
        }
    }

    resolvePrintTimeSet = (resin) => {
        const { printTimeRangeKeys, printTimeResult } = this.props.printTimeData;
        const resinUsageData = [];
        printTimeRangeKeys.forEach(item => {
            if (!printTimeResult[item] || !printTimeResult[item][resin]) {
                resinUsageData.push(0)
            } else {
                resinUsageData.push(printTimeResult[item][resin])
            }
        });
        printTimeSet.labels = printTimeRangeKeys;
        printTimeSet.datasets[0].data = resinUsageData;
    };

    handleResinSelect = (resin) => {
        this.resolvePrintTimeSet(resin);
        this.setState({ anchorEl: null, printTimeSet, selectedResin: resin })
    };

    handleMornResinClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleMornResinClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { resinSets } = this.props.printTimeData;
        const { anchorEl } = this.state;
        let selectedResin = this.state.selectedResin;
        if (!resinSets.includes(selectedResin)) {
            selectedResin = DEFAULT_RESIN;
        }
        const slicedResins = splitItems(resinSets);
        const open = Boolean(anchorEl);
        this.resolvePrintTimeSet(selectedResin);
        return (
            <Col lg={6} md={6} xs={12}>
                {slicedResins.showItems.map((item) => {
                    return (<Button key={item}
                                    variant={item === selectedResin ? 'outlined' : 'text'}
                                    onClick={(ev) => {
                                        this.handleResinSelect(item)
                                    }}>{item}</Button>)
                })}
                {slicedResins.leftItems.length > 0 &&
                (<IconButton
                    aria-label="More"
                    aria-owns={open ? 'print-time' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleMornResinClick}
                >
                    <MoreVertIcon/>
                </IconButton>)
                }

                <Menu
                    id="print-time"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={this.handleMornResinClose}
                    PaperProps={{
                        style: {
                            maxHeight: RESIN_ITEM_HEIGHT * 4.5,
                            width: 200,
                        },
                    }}
                >
                    {slicedResins.leftItems.map(option => (
                        <MenuItem key={option} selected={selectedResin === option}
                                  onClick={(ev) => {
                                      this.handleResinSelect(option)
                                  }}>
                            {option}
                        </MenuItem>
                    ))}
                </Menu>
                <Bar
                    data={printTimeSet}
                    getElementAtEvent={element => {
                        if (element.length === 0) {
                            return
                        }
                        const index = element[0]._index;
                        const label = element[0]._chart.data.labels[index];
                        const value = element[0]._chart.data.datasets[0].data[index];
                        this.props.handleChartsClick({
                            chartType: MASTER_DASHBOARD_CHART_TYPE.PRINT_TIME,
                            label,
                            value,
                            resin: this.state.selectedResin
                        })
                    }}
                    options={{
                        title: {
                            display: true,
                            text: 'Print Time (Min)',
                            fontSize: 20
                        },
                        legend: {
                            display: false,
                            position: 'right'
                        },
                        hover: {
                            animationDuration: 0
                        },
                        animation: {
                            onComplete: (chart) => {
                                addDataOnBar(chart)
                            }
                        }
                    }}
                />
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/print-data-print-time.js